import { createSlice } from "@reduxjs/toolkit";
import { forgotPassword } from "./forgotPassword.action";

const initialState = {
	isPasswordRecovering: false,
	isPasswordRecovered: false,
	isPasswordFailedToRecover: false,
	successMessage: "",
	errorMessage: "",
};

const forgotPasswordSlicer = createSlice({
	name: "forgotPassword",
	initialState: initialState,
	reducers: {
		removeErrorSuccessMessage: (state, action) => {
			state.errorMessage = "";
			state.successMessage = "";
		},
	},
	extraReducers: {
		[forgotPassword.pending]: (state) => {
			state.isPasswordRecovering = true;
		},
		[forgotPassword.fulfilled]: (state, action) => {
			const { message } = action.payload;
			state.isPasswordRecovering = false;
			state.isPasswordRecovered = true;
			state.successMessage = message;
		},
		[forgotPassword.rejected]: (state, action) => {
			const { message } = action.error;
			state.isPasswordRecovering = false;
			state.isPasswordRecovered = false;
			state.isPasswordFailedToRecover = true;

			state.errorMessage = message;
		},
	},
});

export const { removeErrorSuccessMessage } = forgotPasswordSlicer.actions;

export default forgotPasswordSlicer.reducer;
